// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/ANewDialog.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#dialog-overlay.Site-profile-dialog .dialog-container{\r\n    height: calc(100% - 35px);\r\n    max-height: 500px;\r\n    width: 600px;\r\n    max-width: 100%;\r\n}", ""]);
// Exports
module.exports = exports;
